module.exports = __webpack_public_path__ + "img/52.9bafe9e5.jpg";